import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers.ts";
import {BillingUnitConfigCurrent, BillingUnitConfigHistoryEntry} from "@/models/billing-unit-config.ts";
import log from '@/lib/logger';

const BILLING_UNIT_CONFIG_USER_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/billing-unit-config`;
const BILLING_UNIT_CONFIG_ADMIN_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/billing-unit-config`;

export async function getCurrentBillingUnitConfig(token: string | null): Promise<BillingUnitConfigCurrent | void> {
    if (!token) {
        log.error("No token provided for billing unit config retrieval.");
        return Promise.reject("No token provided");
    }

    const response = await fetch(BILLING_UNIT_CONFIG_USER_URL, {
        method: "GET",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
        }),
    });

    return handleResponse<BillingUnitConfigCurrent>(response);
}

export async function getBillingUnitConfigHistory(
    token: string | null,
): Promise<BillingUnitConfigHistoryEntry[] | void> {
    if (!token) {
        log.error("No token provided for billing unit config history retrieval.");
        return Promise.reject("No token provided");
    }

    const response = await fetch(`${BILLING_UNIT_CONFIG_ADMIN_URL}/history`, {
        method: "GET",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
        }),
    });

    return handleResponse<BillingUnitConfigHistoryEntry[]>(response);
}

export async function createBillingUnitConfig(
    token: string | null,
    unitMinutes: number,
): Promise<BillingUnitConfigHistoryEntry | void> {
    if (!token) {
        log.error("No token provided for billing unit config creation.");
        return Promise.reject("No token provided");
    }
    assertTokenValidForMutation()

    const response = await fetch(BILLING_UNIT_CONFIG_ADMIN_URL, {
        method: "POST",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
        }),
        body: JSON.stringify({unitMinutes}),
    });

    return handleResponse<BillingUnitConfigHistoryEntry>(response);
}
